import React, { useEffect, Suspense } from 'react'
import Aside from './components/aside/Aside'
import { useDispatch } from 'react-redux'
import { setPageName, setUserDevice } from './redux'
import Content from './components/content/Content'
import { Navigate, Route, Routes } from 'react-router-dom'
import Login from './components/login/Login'
import NotFound from './components/error/NotFound'
import Server500 from './components/error/Server500'
import UserLogin from './components/user/login/UserLogin'
import VerifyCode from './components/user/login/VerifyCode'
import UserCar from './components/user/details/UserCar'
import CarServiceWithDate from './components/content/views/service/CarServiceWithDate'

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    let page_name = window.location.href.split('/')[3]
    dispatch(setPageName(page_name))
  }, [])

  useEffect(() => {
    function updateDimensions() {
      if (window.screen?.availWidth < 1200) {
        dispatch(setUserDevice('mobile'))
      } else {
        dispatch(setUserDevice('desktop'))
      }
    }

    updateDimensions()
  }, [])

  const token = localStorage.getItem('Token')

  return (
    <Suspense fallback={''}>
      {token ? (
        <div className={'flex w-full'}>
          <Aside />
          <Content />
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<UserLogin />} />
          <Route path="verify-code" element={<VerifyCode />} />
          <Route path="user/car" element={<UserCar />} />
          <Route path={'car/:car_code/service'} element={<CarServiceWithDate isUser={true} />} />
          <Route path="admin" element={<Login />} />
          <Route path="login" element={<Navigate to="/admin" replace />} />
          <Route path="admin/login" element={<Login />} />
          <Route path={'*'} element={<NotFound />} />
          <Route path={'404'} element={<NotFound />} />
          <Route path={'500'} element={<Server500 />} />
        </Routes>
      )}
    </Suspense>
  )
}

export default App
